import React from "react";
import CustomButton from "../../customComponents/customButton.jsx";
import { Box, Container } from "@mui/material";
import { motion } from "framer-motion";
import { translation } from "../../assets/translation";
import {
  commonPaddingLeft,
  commonPaddingRight,
  handleUrl,
  itemVariants,
  language,
  signupurl,
} from "../../assets/function";
import CustomText from "../../customComponents/customText";
import { Colors } from "../../assets/colors";
import HomeImageBg from "../../assets/images/homeImageBg.svg";
import MainHeader from "../../customComponents/MainHeader.jsx";
let staticText = translation[language];

function Header() {
  const handleNavigateOtherClick = (event, url) => {
    handleUrl(url, event);
  };
  const customImageWidth = {
    xs: "100%",
    sm: "100%",
    md: "100%",
    lg: "100%",
    xl: "100%",
  };
  return (
    <Box sx={styles.appBarStyle}>
      <Container maxWidth="xl" sx={styles.containerStyle}>
        {/* Logo for desktop */}
        <Box
          sx={{ flexGrow: 1,  }}
        >
          <motion.div
            variants={itemVariants}
            initial={{ opacity: 0, x: -100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
          >
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <MainHeader
                heading={staticText.andaihub}
                headerStyle={styles.andaihubTxt}
              />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <CustomText
                desc={staticText.getAiReady}
                fontFamily="Inter"
                colorvalue={Colors.getAiReadyTxt}
                style={{ ...styles.getAiReadyTxt }}
                h3
                fontWeight={400}
              />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
            >
              <CustomButton
                style={styles.signuptodayBtn}
                onClick={(event) => {
                  handleNavigateOtherClick(event, signupurl);
                }}
                body={
                  <Box>
                    <CustomText
                      desc={staticText.signUpToday}
                      fontFamily="Epilogue"
                      colorvalue={Colors.signuptxtColor}
                      style={styles.signUpTodayTxt}
                      h4
                      fontWeight={400}
                    />
                  </Box>
                }
              />
            </motion.div>
          </motion.div>
        </Box>

        {/* Desktop menu */}

        <Box
          sx={{
            flexGrow: 0,
            display: { xs: "flex", md: "flex" },
            
            ...styles.subcontent1,
          }}
        >
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
            style={{ width: "100%" }}
          >
            <Box
              component="img"
              src={HomeImageBg}
              alt={"homeImageBg"}
              sx={{
                width: customImageWidth,
                objectFit: "cover",
                marginTop: { xs: 3, sm: 4, md: 5, lg: 6 },
              }}
            />
          </motion.div>
        </Box>
      </Container>
    </Box>
  );
}

export default Header;

const styles = {
  getAiReadyTxt: {
    marginBottom: 4,
    lineHeight: 1.5,
    fontStyle: "initial",
  },
  andaihubTxt: {
    textAlign: "left",
    marginBottom: 1,
    lineHeight: 1.1,
    letterSpacing: "-0.01em",
    fontStyle: "initial",
    fontSize: {
      xs: "2rem", // for mobile (<600px)
      sm: "2.5rem", // for tablets (600px+)
      md: "3rem", // for small laptops (900px+)
      lg: "3.5rem", // for laptops/desktops (1200px+)
      xl: "3.5rem", // for large screens (1536px+)
    },
  },

  subcontent1: {
    
    maxWidth: {
      xs: "50%", // for mobile (<600px)
      sm: "40%", // for tablets (600px+)
      md: "55%", // for small laptops (900px+)
      lg: "40%", // for laptops/desktops (1200px+)
      xl: "60%", // for large screens (1536px+)
    },
  },
  signuptodayBtn: {
    backgroundColor: Colors.signUpButtonTxt,
    borderRadius: 1,
    paddingTop: {
      xs: 1, // smaller padding for mobile
      sm: 1.2, // slightly larger for tablets
      md: 1.5, // default size for larger screens
    },
    paddingBottom: {
      xs: 1,
      sm: 1.2,
      md: 1.5,
    },
    paddingLeft: {
      xs: 1.5, // smaller horizontal padding for mobile
      sm: 2, // medium for tablets
      md: 2.3, // default size for larger screens
    },
    paddingRight: {
      xs: 1.5,
      sm: 2,
      md: 2.3,
    },
    boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.25)",
  },
  signUpTodayTxt: {
    textTransform: "none",
    fontSize: {
      xs: "0.875rem", // 14px for mobile
      sm: "1rem", // 16px for tablets
      md: "1.125rem", // 18px for desktop
    },
  },
  content: {
    boxSizing: "border-box",
    marginTop: {
      xs: 4, // for mobile (<600px)
      sm: 5, // for tablets (600px+)
      md: 6, // for small laptops (900px+)
      lg: 7, // for laptops/desktops (1200px+)
      xl: 8, // for large screens (1536px+)
    },
    justifyItems: "center",
    justifyContent: "space-between",
    width: "100%",
    display: "flex",
    alignItems: "center",
  },
  appBarStyle: {
    overflowX: "hidden", // Prevent horizontal scrolling
    boxSizing: "border-box",
    backgroundColor: Colors.themeColor,
    paddingLeft: commonPaddingLeft,
    paddingRight: commonPaddingRight,
  },

  containerStyle: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: {
      xs: 4, // for mobile (<600px)
      sm: 5, // for tablets (600px+)
      md: 1, // for small laptops (900px+)
      lg: 8, // for laptops/desktops (1200px+)
      xl: 2, // for large screens (1536px+)
    },
    alignItems: "center",
    gap: 0,
  },
};
